import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X, Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_4ced9567-878b-4197-bbc3-520d4526f79c/artifacts/lx2s7y4x_logo_s.png";

const navLinks = [
  { href: "/", label: "Acasă" },
  { href: "/despre", label: "Despre Noi" },
  { href: "/servicii", label: "Servicii" },
  { href: "/galerie", label: "Galerie" },
  { href: "/certificari", label: "Certificări" },
  { href: "/contact", label: "Contact" },
];

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-[#D4D4D4]" data-testid="header">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="SC SOLAR CONSTRUCT SRL" 
              className="h-12 md:h-14"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-xs font-bold tracking-[0.2em] uppercase transition-colors hover:text-[#FACC15] ${
                  location.pathname === link.href ? "text-[#FACC15]" : "text-[#0A0A0A]"
                }`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:flex items-center gap-4">
            <a href="tel:+40722344534" className="flex items-center gap-2 text-sm font-semibold text-[#0A0A0A]">
              <Phone className="w-4 h-4" />
              <span>+40 722 344 534</span>
            </a>
            <Button 
              asChild
              className="bg-[#FACC15] text-[#0A0A0A] hover:bg-yellow-400 rounded-none font-bold tracking-wider uppercase text-xs px-6"
              data-testid="header-cta-btn"
            >
              <Link to="/servicii">Comandă Acum</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-[#D4D4D4] py-4" data-testid="mobile-menu">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-xs font-bold tracking-[0.2em] uppercase py-2 transition-colors ${
                    location.pathname === link.href ? "text-[#FACC15]" : "text-[#0A0A0A]"
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="pt-4 border-t border-[#D4D4D4]">
                <a href="tel:+40722344534" className="flex items-center gap-2 text-sm font-semibold text-[#0A0A0A] mb-4">
                  <Phone className="w-4 h-4" />
                  <span>+40 722 344 534</span>
                </a>
                <Button 
                  asChild
                  className="w-full bg-[#FACC15] text-[#0A0A0A] hover:bg-yellow-400 rounded-none font-bold tracking-wider uppercase text-xs"
                  data-testid="mobile-cta-btn"
                >
                  <Link to="/servicii" onClick={() => setMobileMenuOpen(false)}>Comandă Acum</Link>
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
